import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ReduxState } from 'ducks';

import { fetchInstantWinEvents } from 'ducks/client/instantWinEvent';
import { ApiKeyContext } from 'contexts/ApiKeyContext';

import { InstantWinPopup } from './InstantWinPopup';

export const InstantWinPopupStampRally = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const stampRally = useSelector(
    (state: ReduxState) => state.universal.digitalGuidanceStampRally.stampRally
  );
  const instantWinEvents = useSelector((state: ReduxState) => state.instantWinEvent.all);

  const { apiKey } = React.useContext(ApiKeyContext);

  React.useEffect(() => {
    if (!stampRally) {
      return;
    }
    if (stampRally.stamp_count == (stampRally?.stamp_rally_redemptions?.length || 0)) {
      const lastRedemption = stampRally?.stamp_rally_redemptions.slice(-1)[0];
      dispatch(
        fetchInstantWinEvents(apiKey, lastRedemption.id, i18n.language, [
          'INSTANT_WIN_EVENT_PENDING',
          'INSTANT_WIN_EVENT_OPENED',
          'INSTANT_WIN_EVENT_EXPIRED',
        ])
      );
    }
  }, [stampRally, apiKey, dispatch, i18n.language]);

  if (!instantWinEvents || instantWinEvents.length === 0) {
    return null;
  }

  return <InstantWinPopup instantWinEvent={instantWinEvents[0]} />;
};
